module.exports = __webpack_public_path__ + "media/img/flags/Spain-5fa381a8eb16d9e673d32980e7fd1710.png";